// MODULES
import React from "react";

export default function DefaultFields({ fields }) {
    return (
        <div className="Cob-DefaultFields" style={{ display: "none" }}>
            { fields.map(name => ( 
                <input key={ name } type="hidden" name={ name } value="" />
            ))}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/DefaultFields/DefaultFields.js